<template>
  <div>
    <el-row
      :gutter="12"
      class="mt-2"
      v-loading.fullscreen.lock="loyaltyPurchases.isLoading"
    >
      <el-row type="flex" justify="space-between" align="middle" class="mb-4">
        <p class="category-title ma-0">Loyalty Purchase</p>

        <el-col :span="16">
          <el-row type="flex" justify="end">
            <el-button style="margin-right: 10px" type="primary" size="small">
              <download-excel
                :data="loyaltyPurchases.data"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="Loyalty purchase.xls"
              >
                Download Pengajuan
              </download-excel>
            </el-button>

            <el-select
              v-model="optionView"
              size="small"
              placeholder="Select"
              class="mr-2"
              @change="
                (e) => {
                  toAnotherPage(page, e, form.search, valueStatus),
                    settingTable(page, e);
                }
              "
              style="width: 100px"
            >
              <el-option
                v-for="item in optionsView"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-input
              size="small"
              v-model="form.search"
              placeholder="Search by branch or customer name"
              style="width: 200px"
              class="mr-2"
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-table
          empty-text="Tidak ada data"
          :data="loyaltyPurchases.data"
          style="width: 100%"
        >
          <el-table-column
            sortable
            prop="branch"
            label="Branch"
            width="180"
          ></el-table-column>
          <el-table-column
            sortable
            prop="orderId"
            label="Order ID"
            width="180"
          ></el-table-column>
          <el-table-column
            sortable
            prop="customerName"
            label="Customer Name"
            width="180"
          ></el-table-column>
          <el-table-column
            sortable
            prop="itemName"
            label="Item Name"
            width="180"
          ></el-table-column>
          <el-table-column
            sortable
            prop="point"
            label="Point"
            width="180"
          ></el-table-column>
          <el-table-column sortable prop="status" label="Status" width="180">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 'on_progress'" effect="dark"
                >Dalam Proses</el-tag
              >
              <el-tag
                v-else-if="scope.row.status === 'delivery'"
                type="info"
                effect="dark"
                >Dalam Pengiriman</el-tag
              >
              <el-tag
                v-else-if="scope.row.status === 'cancel'"
                type="danger"
                effect="dark"
                >Cancel</el-tag
              >
              <el-tag
                v-else-if="scope.row.status === 'done'"
                type="success"
                effect="dark"
                >Selesai</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="dateTime"
            label="Date Time"
            width="180"
          ></el-table-column>
          <el-table-column
            sortable
            prop="balancePoint"
            label="Balance Point"
            width="180"
          ></el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="Action"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                circle
                :disabled="
                  scope.row.status === 'done' || scope.row.status === 'cancel'
                "
                @click="
                  () => {
                    (dialogFormVisible = true),
                      (payload = {
                        id: scope.row.id,
                        status: scope.row.status,
                        idx: scope.row.idx,
                      });
                  }
                "
              ></el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-close"
                circle
                @click="
                  () => {
                    (dialogFormConfirmation = true),
                      (payload = {
                        id: scope.row.id,
                        status: 'cancel',
                        idx: scope.row.idx,
                      });
                  }
                "
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            layout="prev, pager, next"
            :total="loyaltyPurchases.count"
            :current-page="parseInt(page)"
            @current-change="
              (e) => {
                toAnotherPage(e, optionView, form.search, valueStatus),
                  settingTable(e, optionView);
              }
            "
            :page-size="parseInt(optionView)"
          ></el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title="Update status loyalty purchase"
      :visible.sync="dialogFormVisible"
    >
      <el-radio-group v-model="payload.status">
        <el-radio label="on_progress">DALAM PROSES</el-radio>
        <el-radio label="delivery">DALAM PENGIRIMAN</el-radio>
        <el-radio label="cancel">CANCEL</el-radio>
        <el-radio label="done">SELESAI</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateStatus">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="dialogFormConfirmation">
      <div style="justify-content: center; display: flex">
        <h3>Apakah anda yakin cancel loyalty purchase ini?</h3>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormConfirmation = false">Cancel</el-button>
        <el-button type="primary" @click="updateStatus">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import ApiService from "../../common/api.service";
export default {
  data() {
    return {
      dialog: false,
      payload: {
        id: 0,
        status: 'NEW',
        idx: 0
      },
      form: {
        search: ""
      },
      optionsView: [
        {
          value: 1,
          label: "1"
        },
        {
          value: 2,
          label: "2"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      optionsStatus: [
        {
          value: 'done',
          label: "Done"
        },
        {
          value: 'on_progress',
          label: "On Progress"
        },
        {
          value: 'payment_confirmation',
          label: "Menunggu Pembayaran"
        },
        {
          value: 'pending',
          label: "Tertunda"
        },
        {
          value: 'delivery',
          label: "Dalam Pengiriman"
        },
      ],
      valueStatus: 'on_progress',
      page: 1,
      dialogFormVisible: false,
      dialogFormConfirmation: false,
      json_fields: {
        No: {
          field: "idx",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        "Kode Cabang": "branch",
        "Nama Cabang": "branch",
        "Nama Customer": "customerName",
        "Kode Customer": "customerName",
        "Nama Barang": "itemName",
        "Tanggal": "dateTime",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getLoyaltyPurchases: "loyaltyPurchase/GetLoyaltyPurchases",
    }),
    async updateStatus() {
      try {
        await ApiService.put(
          `/v1/loyalty/purchase-history/status/`,
          {
            purchaseHistoryId: this.payload.id,
            status: this.payload.status
          }
        );
        Message({
          message: "Update completed",
          type: "success"
        });
        this.loyaltyPurchases.data[this.payload.idx].status = this.payload.status
        this.dialogFormVisible = false
        this.dialogFormConfirmation = false
      } catch (e) {
        Message({
          message: "Update error",
          type: "error"
        });
      }
    },
    toAnotherPage(page, limit, search) {
      this.$router.push({ path: "/loyalty-purchase", query: { page: page, limit: limit, search: search } });
    },
    onSearch() {
      this.$router.replace({ path: "/loyalty-purchase", query: { page: 1, limit: 25, search: this.form.search } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getLoyaltyPurchases(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search;
      this.valueStatus = this.$router.history.current.query.status;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search,
        }
      };
      if (this.valueStatus !== '') {
        option = {
          params: {
            ...option.params,
          }
        }
      }
      this.getLoyaltyPurchases(option);
    }
  },
  computed: {
    ...mapState({
      loyaltyPurchases: state => state.loyaltyPurchase.loyaltyPurchases
    })
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    this.form.search = this.$router.history.current.query.search || '';
    this.valueStatus = this.$router.history.current.query.status || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search,
      }
    };
    this.getLoyaltyPurchases(option);
  }
};
</script>

<style>
.custom-container {
  padding-top: 0px !important;
}
.custom-table thead {
  background-color: #dee2e6;
}
.custom-table thead tr th {
  font-weight: bold;
}
.custom-table tbody {
  background-color: #f8f9fa;
}
</style>
